import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FalhaServico } from 'src/app/models/falha-servico';
import { CartaoCredito, Consorcio, Consumo, Detalhe, DetalheParcelaRotativo, InformacaoPositivo, Parcelado, Rotativo } from 'src/app/models/positivo/info-positivo';
import { UtilLarguraTela } from 'src/app/utils/configuracoes/util-largura-tela';
import { MensagemRetorno } from 'src/app/utils/mensagens.retorno';
import { FotografiaService } from '../../fotografia/fotografia.service';
import { BlocoInformacoesPositivasService } from './bloco-informacoes-positivas.service';

@Component({
  selector: 'app-bloco-informacoes-positivas',
  templateUrl: './bloco-informacoes-positivas.component.html',
  styleUrls: ['./bloco-informacoes-positivas.component.scss']
})
export class BlocoInformacoesPositivasComponent implements OnInit {

  constructor(private fotografiaService: FotografiaService, private blocoInformacoesPositivasService : BlocoInformacoesPositivasService) { }
  public larguraEhSuperiorMin: boolean;
  public falhaServico: FalhaServico;
  public listaServicoFalha: Array<string>;
  public listaPositivoConsorcio : Array<Consorcio>;
  public listaPositivoCartaoCredito : Array<CartaoCredito>;
  public listaPositivoRotativo : Array<Rotativo>;
  public listaPositivoParcelado : Array<Parcelado>;
  public listaPositivoConsumo : Array<Consumo>;
  public informacaoPositivo: InformacaoPositivo;
  public totalInfoPositivo: number;
  @Output() totalizadorInfoPositivo: EventEmitter<number> = new EventEmitter();
  @Input() recebeLoadingEvento: boolean;
  @Output() emiteLoadingEvento = new EventEmitter();
  @Output() mensagemPositivo: EventEmitter<string> = new EventEmitter();



  ngOnInit(): void {
    this.totalInfoPositivo = 0;
    this.falhaServico = new FalhaServico();
    this.listaServicoFalha = new Array();
    this.listaPositivoConsorcio = new Array();
    this.listaPositivoCartaoCredito = new Array();
    this.listaPositivoRotativo = new Array();
    this.listaPositivoParcelado = new Array();
    this.listaPositivoConsumo = new Array();
    this.larguraEhSuperiorMin = UtilLarguraTela.checarLarguraTela();

  }

  capturaErro(retornoErro: any, servico: string) {
    this.falhaServico = retornoErro.error[0];
    this.falhaServico.bloco = servico;
    this.listaServicoFalha.push(servico);
    if(retornoErro.status !== 404){
      this.falhaServico.message = MensagemRetorno.mensagemRetornoStatus(retornoErro.status);
      this.mensagemPositivo.emit(this.falhaServico.message);
    }else{
      this.mensagemPositivo.emit(this.falhaServico.message);
    }

  }

  ngAfterViewInit(){
    this.consultarInformacoesPositivo();
  }

  consultarInformacoesPositivo() {
    this.informacaoPositivo = new InformacaoPositivo();
    this.blocoInformacoesPositivasService.consultarInformacoesPositivo().subscribe(res => {
      if (res.operacoes.length > 0) {
        for (let index = 0; index < res.operacoes.length; index++) {
          const operacao = res.operacoes[index];
          if (operacao !== undefined) {
            this.definirTipoOperacao(operacao);
          }
        }
      }
      this.fotografiaService.concatenarFotografia(res, 'info-positivo');
      this.totalizadorInfoPositivo.emit(this.totalInfoPositivo);
      this.mensagemPositivo.emit(MensagemRetorno.mensagemRetornoStatus('200'));

    }, err => {
      this.totalizadorInfoPositivo.emit(this.totalInfoPositivo);
      this.capturaErro(err, 'info-positivo');
      this.fotografiaService.concatenarFotografia(err, 'info-positivo');
    })
    .add(() => this.emiteLoadingEvento.emit("info-positivo"));
  }


  /**
 *
* S -> Consórcio
* P -> Parcelado
* R -> Rotativo
* C -> Cartão de Crédito
* U -> Utility
 */
  private definirTipoOperacao(operacao: any) {
    switch (operacao.tipoModalidade.toUpperCase()) {
      case 'S':
        let operacaoConsorcio = new Consorcio();
        operacaoConsorcio = operacao;
        if (operacaoConsorcio.detalhe12Meses.length == 0) {
          operacaoConsorcio.detalhe12Meses.push(new Detalhe());
        }
        this.listaPositivoConsorcio.push(operacaoConsorcio);
        this.totalInfoPositivo++;
        break;

      case 'C':
        let operacaoCartaoCredito = new CartaoCredito();
        operacaoCartaoCredito = operacao;
        if (operacaoCartaoCredito.detalhe12Meses.length == 0) {
          operacaoCartaoCredito.detalhe12Meses.push(new Detalhe());
        }
        this.listaPositivoCartaoCredito.push(operacaoCartaoCredito);
        this.totalInfoPositivo++;
        break;

      case 'P':
        let operacaoParcelado = new Parcelado();
        operacaoParcelado = operacao;
        if (operacaoParcelado.detalhe12Meses.length == 0) {
          operacaoParcelado.detalhe12Meses.push(new Detalhe());
        }
        this.listaPositivoParcelado.push(operacaoParcelado);
        this.totalInfoPositivo++;
        break;

      case 'U':
        case 'T':
        let operacaoConsumo = new Consumo();
        operacaoConsumo = operacao;
        if (operacao.detalhe12Meses.length == 0) {
          operacao.detalhe12Meses.push(new Detalhe());
        }
        this.listaPositivoConsumo.push(operacao);
        this.totalInfoPositivo++;
        break;

      case 'R':
        let operacaoRotativo = new Rotativo();
        operacaoRotativo = operacao;
        if (operacaoRotativo.detalhe12Meses.length == 0) {
          operacaoRotativo.detalhe12Meses.push(new DetalheParcelaRotativo());
        }
        this.listaPositivoRotativo.push(operacaoRotativo);
        this.totalInfoPositivo++;
        break;
    }
  }
}
